import { render } from "./CtxButton.vue?vue&type=template&id=20793cd4&scoped=true"
import script from "./CtxButton.vue?vue&type=script&lang=js"
export * from "./CtxButton.vue?vue&type=script&lang=js"

import "./CtxButton.vue?vue&type=style&index=0&id=20793cd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20793cd4"]])

export default __exports__